import {getSelectedVendorFromStorage} from 'utils/Helper';

export const getCustomDealVendorId = (): number => {
  const vendorId = getSelectedVendorFromStorage()?.id;
  const parsed = Number(vendorId);

  return Number.isFinite(parsed) ? parsed : 0;
};

export const formatDealDateRange = (startDate?: string, endDate?: string): string => {
  const options: Intl.DateTimeFormatOptions = {month: 'long', day: 'numeric'};

  return `${new Date(startDate ?? '').toLocaleDateString('fa-IR', options)} - ${new Date(
    endDate ?? ''
  ).toLocaleDateString('fa-IR', options)}`;
};

export const formatDealDateWithWeekday = (dateString?: string): string => {
  if (!dateString) {
    return '';
  }

  const date = new Date(dateString);
  const weekday = date.toLocaleDateString('fa-IR', {weekday: 'long'});
  const day = date.toLocaleDateString('fa-IR', {day: 'numeric'});
  const month = date.toLocaleDateString('fa-IR', {month: 'long'});
  const year = date.toLocaleDateString('fa-IR', {year: 'numeric'});

  return `${weekday} ${day} ${month} ${year}`;
};

export const getRemainingDays = (startDate?: string): number => {
  if (!startDate) {
    return 0;
  }

  return Math.max(0, Math.ceil((new Date(startDate).getTime() - Date.now()) / (1000 * 60 * 60 * 24)));
};
